/* eslint-disable no-magic-numbers */
import { styled } from "@mui/material";
import { Link } from "react-router-dom";
import React from "react";
import colors from "../../theme/themeConstants";
import { routes } from "routes";

interface IKeyboardProps {
  currentSelectedChar: string | null;
}

const InputKeyboardSingleChar = ({ currentSelectedChar }: IKeyboardProps) => {
  // create alphabet
  const ALPHABET = Array.from(Array(26)).map((e, i) => i + 65).map((x) => String.fromCharCode(x));

  const renderKeyboardLine = (letterArr: string[]) => (
    <StyledKeyboardContainer >
      {letterArr.map((letter, index) => (
        <StyledKeyboardButton key={index} to={routes.trendingTagsA(letter.toLowerCase())} sx={{
          border: currentSelectedChar === letter ? `2px solid ${colors.redPink}` : "none",
        }}>
          {letter.toUpperCase()}
        </StyledKeyboardButton>
      ))}
    </StyledKeyboardContainer>
  );

  return (
    <Container>
      {window.innerWidth < 900 ?
        <React.Fragment>
          {renderKeyboardLine(ALPHABET.slice(0, 9))}
          {renderKeyboardLine(ALPHABET.slice(9, 17))}
          {renderKeyboardLine(ALPHABET.slice(17, 26))}
        </React.Fragment>

        :

        <React.Fragment>
          {renderKeyboardLine(ALPHABET.slice(0, 14))}
          {renderKeyboardLine(ALPHABET.slice(14, 26))}
        </React.Fragment>
      }
    </Container>
  );
};

export default InputKeyboardSingleChar;

const Container = styled("div")({
  maxWidth: "340px",
  margin: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const StyledKeyboardContainer = styled("div")({
  backgroundColor: colors.lightGray_GoBackButton,
  display: "flex",
  alignItems: "center",
  borderRadius: "12px",
  maxHeight: "1rem",
  overflow: "visible",
  width: "min-content",
  marginBottom: "1.5rem",
});

const StyledKeyboardButton = styled(Link)({
  display: "flex",
  cursor: "pointer",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  minWidth: "unset",
  borderRadius: "1rem",
  width: "34px",
  height: "34px",
  background: colors.lightGray_GoBackButton,
  color: "white",
  ":hover": {
    background: colors.lightGray_GoBackButton,
  }
});
